import React from "react";

/**
 * A loading or empty message as a real table row.
 *
 * Every list screen used to render these states as a bare <div> inside <tbody>.
 * React inserts nodes with appendChild rather than through the HTML parser, so
 * the div did land in the table -- but as an anonymous box outside the column
 * model, which is why the message sat out of line with the grid. A <tr> with a
 * spanning <td> is both valid and correctly positioned.
 *
 * `colSpan` must match the number of <th> in the table's header, otherwise the
 * row will not span the full width.
 *
 * Pass `loading` to show the shared spinner instead of a text message.
 */
const TableStateRow = ({ colSpan, loading, children }) => (
  <tr className="table-state-row">
    <td colSpan={colSpan} className="table-state">
      {loading ? (
        <span className="table-state-spinner" role="status" aria-label="Loading" />
      ) : (
        children
      )}
    </td>
  </tr>
);

export default TableStateRow;
